"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeQueryParameter = void 0;
var _updateQueryParameters = require("./updateQueryParameters");
/**
 * Removes query parameter from browser URL
 */ var removeQueryParameter = function(name) {
    var queryParams = new URLSearchParams(window.location.search);
    if (!queryParams.has(name)) {
        return;
    }
    queryParams.delete(name);
    (0, _updateQueryParameters.updateQueryParameters)(queryParams);
};
exports.removeQueryParameter = removeQueryParameter; //# sourceMappingURL=removeQueryParameter.js.map
